export default __webpack_public_path__ + "static/media/email.43b17d91.svg";